import React from 'react';
import { NavLink } from 'react-router-dom';
import config from '../../../../config/sbf_config';

export default function SidebarLink(props) {
    const {
        route, title, icon, onClick, external_link,
    } = props;

    if (title === 'Cancelled Collections') {
        return (
            <li className="sidebar__link">
                <p><a className="sidebar__link-title" href={`${config.newCrmUrl}/purchasing/leads/cancelled-collections`}>{title}</a></p>
            </li>
        );
    }

    return (
        external_link
            ? (
                <li className="sidebar__link">
                    <p><a className="sidebar__link-title" href={external_link} target="_blank" rel="noreferrer">{title}</a></p>
                </li>
            )
            : (
                <NavLink to={route || '/'} onClick={onClick}>
                    <li className="sidebar__link">
                        {icon ? <span className={`sidebar__link-icon lnr lnr-${icon}`} /> : ''}
                        <p className="sidebar__link-title">{title}</p>
                    </li>
                </NavLink>
            )
    );
}



// WEBPACK FOOTER //
// ./src/modules/App/components/sidebar/SidebarLink.js